export { default as useIntersectionObserver } from './useIntersectionObserver';
export * from './useIntersectionObserver';
//# sourceMappingURL=index.js.map